import { getPreparationSourceAuthors } from "./preparationSourceAuthors";

// Preserve every admitted care observation even if AI drafting selects only a subset.
export const buildCoveredPeriodSection = (evidence = []) => {
  const entries = [
    ...new Map(
      evidence
        .filter((item) => item.handoverRecord && item.sourceType === "timeline")
        .map((item) => [item.sourceId, item]),
    ).values(),
  ];
  if (!entries.length) return null;
  return {
    id: "covered_period_entries",
    title: "Care recorded in this period",
    statements: entries.map((item) => ({
      id: `timeline:${item.sourceId}`,
      text: item.description || item.label,
      origin: "care_record_observation",
      sourceIds: [`timeline:${item.sourceId}`],
      sourceAuthors: getPreparationSourceAuthors(
        [`timeline:${item.sourceId}`],
        entries,
      ),
    })),
  };
};
